module.exports = __webpack_public_path__ + "assets/64a688c92adf2cd4fa4718f6c1f42a28.png";